/** Build login path with optional post-login redirect (must start with /). */
import { resolvePostLoginDestination, rememberPostLoginRedirect } from '../../config/routes';

export function buildLoginPath(redirectPath) {
  const normalized = redirectPath
    ? resolvePostLoginDestination(redirectPath)
    : undefined;
  if (normalized) {
    rememberPostLoginRedirect(normalized);
  }
  const redirect =
    normalized && normalized.startsWith('/') && !normalized.startsWith('//')
      ? normalized
      : undefined;
  return redirect
    ? `/login?redirect=${encodeURIComponent(redirect)}`
    : '/login';
}

/** Navigate to sign-in (React Router + hard fallback if navigation is blocked). */
export function goToLogin(navigate, redirectPath) {
  const path = buildLoginPath(redirectPath);
  try {
    navigate(path);
  } catch {
    window.location.assign(path);
  }
}

export function openLoginPage(redirectPath) {
  window.location.assign(buildLoginPath(redirectPath));
}
